module.exports = __webpack_public_path__ + "static/img/menu-about-join.335bcc7c.png";